import React from 'react';
import CardTemp from './CardTemplate';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import styles from '../css/altParking.module.css';
library.add(faCircleInfo);

function CardView() {
  document.getElementById('lastcard').scrollIntoView();
}

function AltParkingTabContent() {
  document.onload = function () {
    CardView();
  };
  return (
    <div>
      <h5 style={{ padding: 10 }}>
        Please note that NYP Parking Department has no relationship or is not
        affiliated with any of the parking operators or the websites listed on
        this page. For specific questions regarding parking rates, location
        details, hours of operation, space availability, or dispute resolution,
        we highly recommend that you contact the respective parking operators
        directly.
      </h5>
      <div className={styles.topContainer} id="mainframe">
        <CardTemp
          cardLink="#"
          imgShow="false"
          imgTitle="Columbia Campus Alternate Parking"
          def1=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://spothero.com/search?kind=address&latitude=40.8399581&longitude=-73.9420394&search_string=New+York+Presbyterian+Hospital-Columbia%3A+Cancer+Center%2C+West+168th+Street%2C+New+York%2C+NY%2C+USA'
              );
            }}
          >
            SpotHero Listed Locations
          </button>
          def2=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://www.parkwhiz.com/destination/115-Fort-Washington-Avenue-New-York-NY/?lat=40.84005837470821&lng=-73.94164290345077'
              );
            }}
          >
            ParkWiz Listed Locations
          </button>
          def3=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://www.bestparking.com/destination/115-Fort-Washington-Ave-New-York-NY/?lat=40.83796329345279&lng=-73.94235503613328'
              );
            }}
          >
            BestParking Listed Locations
          </button>
          def4=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://en.parkopedia.com/parking/locations/115_fort_washington_avenue_new_york_city_new_york_10032_united_states_i93ddr72m6eqntc1e0/?arriving=202309031030&leaving=202309031230'
              );
            }}
          >
            ParkOpedia Listed Locations
          </button>
          def5=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://parking.com/nyc/parking-near/40.8396422/-73.9435056/115-fort-washington-ave?start=2025-07-09T18%3A30&stop=2025-07-09T20%3A30&lot_id=&showListOnly=0&view=daily&sw=40.83515812484163,-73.94852394516737&ne=40.843378337425065,-73.93004498642726&facility&valet=n&general=&displayFullCity=0'
              );
            }}
          >
            SPPLUS Listed Locations
          </button>
          def6=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://go.lazparking.com/search-results/115-Fort-Washington-Ave-New-York-NY-10032-USA?start=2025-07-09T21%3A45%3A27.824Z&end=2025-07-09T23%3A45%3A27.824Z'
              );
            }}
          >
            LAZ Parking Listed Locations
          </button>
        />
        <CardTemp
          cardLink="#"
          imgShow="false"
          imgTitle="Cornell Campus Alternate Parking"
          def1=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                `https://spothero.com/search?kind=address&latitude=40.7649151&longitude=-73.954897&search_string=Weill+Cornell
                +Medicine%2C+York+Avenue%2C+New+York%2C+NY%2C+USA&ends=2025-07-23T13%3A00&starts=2025-07-23T10%3A00&view=dl`
              );
            }}
          >
            SpotHero Listed Locations
          </button>
          def2=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://www.parkwhiz.com/destination/435-East-68th-Street-New%20York-NY/?lat=40.764351&lng=-73.955745'
              );
            }}
          >
            ParkWiz Listed Locations
          </button>
          def3=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://www.bestparking.com/ny-ny-parking/destinations/new-york-presbyterian-hospital-parking/?daily=1'
              );
            }}
          >
            BestParking Listed Locations
          </button>
          def4=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://en.parkopedia.com/parking/locations/525_east_68th_street_new_york_city_new_york_10065_united_states_e47cdr5rvhgvxdnc79/?country=us&arriving=202309031130&leaving=202309031330'
              );
            }}
          >
            ParkOpedia Listed Locations
          </button>
          def5=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://parking.com/nyc/parking-near/40.7653475/-73.95372689999999/519-e-70th-st?start=2025-07-09T18%3A30&stop=2025-07-09T20%3A30&lot_id=&showListOnly=0&view=daily&sw&ne&facility&valet=n&general=&displayFullCity=0'
              );
            }}
          >
            SPPLUS Listed Locations
          </button>
          def6=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://go.lazparking.com/search-results/1283-York-Avenue-New-York-NY?start=2025-07-09T21%3A55%3A48.370Z&end=2025-07-09T23%3A55%3A48.370Z'
              );
            }}
          >
            LAZ Parking Listed Locations
          </button>
        />
        <CardTemp
          cardLink="#"
          imgShow="false"
          imgTitle="Methodist Campus Alternate Parking"
          def1=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://spothero.com/search?kind=address&latitude=40.6686663&longitude=-73.98035349999999&search_string=500+6th+Street%2C+Brooklyn%2C+NY%2C+USA&starts=2023-08-15T09%3A00&ends=2023-08-15T12%3A00'
              );
            }}
          >
            SpotHero Listed Locations
          </button>
          def2=<button
            className={styles.btns}
            id="wiz"
            type="button"
            onClick={() => {
              window.open(
                'https://www.parkwhiz.com/destination/500-6th-Street-New-York-NY/?lat=40.668772891719755&lng=-73.97640366247418'
              );
            }}
          >
            ParkWiz Listed Locations
          </button>
          def3=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://www.bestparking.com/destination/500-6th-Street-New-York-NY/?lat=40.668787056833224&lng=-73.98140533051998'
              );
            }}
          >
            BestParking Listed Locations
          </button>
          def4=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://en.parkopedia.com/parking/locations/500_6th_avenue_brooklyn_new_york_11215_united_states_999hdr5rk7j0etd7ia/?country=us&arriving=202309031130&leaving=202309031330'
              );
            }}
          >
            ParkOpedia Listed Locations
          </button>
          def5=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://parking.com/nyc/parking-near/40.66845829999999/-73.9790694/501-6th-st?start=2025-07-09T19%3A30&stop=2025-07-09T20%3A30&lot_id=&showListOnly=0&view=daily&sw&ne&facility&valet=n&general=&displayFullCity=0'
              );
            }}
          >
            SPPLUS Listed Locations
          </button>
          def6=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://go.lazparking.com/search-results/501-Brooklyn-NY?start=2025-07-09T22%3A45%3A26.958Z&end=2025-07-10T00%3A45%3A26.958Z'
              );
            }}
          >
            LAZ Parking Listed Locations
          </button>
        />
        <CardTemp
          cardLink="#"
          imgShow="false"
          imgTitle="Lower Manhattan Hospital Alternate Parking"
          def1=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://spothero.com/search?kind=address&latitude=40.7106783&longitude=-74.00575649999999&search_string=8+Spruce+Street%2C+New+York%2C+NY%2C+USA'
              );
            }}
          >
            SpotHero Listed Locations
          </button>
          def2=<button
            className={styles.btns}
            id="wiz"
            type="button"
            onClick={() => {
              window.open(
                'https://www.parkwhiz.com/destination/8-Spruce-Street-New-York-NY/?lat=40.711431492924504&lng=-74.0054452652937'
              );
            }}
          >
            ParkWiz Listed Locations
          </button>
          def3=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://www.bestparking.com/destination/25-Beekman-Street-New-York-NY/?lat=40.71089935642857&lng=-74.00505157312818'
              );
            }}
          >
            BestParking Listed Locations
          </button>
          def4=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://en.parkopedia.com/parking/locations/8_spruce_street_8_spruce_st_new_york_city_new_york_10038_united_states_44gddr5regq8k6hhhb/?country=us&arriving=202309031130&leaving=202309031330'
              );
            }}
          >
            ParkOpedia Listed Locations
          </button>
          def5=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://parking.com/nyc/parking-near/40.71109260000001/-74.0056438/8-spruce-street?start=2025-07-09T19%3A30&stop=2025-07-09T20%3A30&lot_id=&showListOnly=0&view=daily&sw&ne&facility&valet=n&general=&displayFullCity=0'
              );
            }}
          >
            SPPLUS Listed Locations
          </button>
          def6=<button
            className={styles.btns}
            id="hero"
            type="button"
            onClick={() => {
              window.open(
                'https://go.lazparking.com/search-results/8-Spruce-Street-Spruce-Street-New-York-NY?start=2025-07-09T22%3A50%3A47.233Z&end=2025-07-10T00%3A50%3A47.233Z'
              );
            }}
          >
            LAZ Parking Listed Locations
          </button>
        />
      </div>
    </div>
  );
}
export default AltParkingTabContent;
